var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',[_c('p',{staticClass:"text-center text-muted"},[_vm._v("© SAT LA PLANA 9422")])])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }